<nav class="ub-pagination">
  <li *ngIf="start > 1"><button (click)="select(1)">&laquo;</button></li>
  <li *ngIf="start > 1"><span>...</span></li>
  <li [ngClass]="{'current': page.page === currentPage}" *ngFor="let page of buttons">
    <button (click)="select(page.page)">{{page.title}}</button>
  </li>
  <li *ngIf="end < pagesCount"><span>...</span></li>
  <li *ngIf="end < pagesCount"><button (click)="select(pagesCount)">&raquo;</button></li>
</nav>
